module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAAHz3l9RAAAAAXNSR0IArs4c6QAAAN1JREFUKBWNULsNwjAQdYQEHQ0D0DIBC1DRM0J2YAhmoGcLemaghCpxfrZDHBnMOwtHtkQQlpy7e3fv3YsZ88dau8C1vmZJVGVZVkeAn0sooU6e59eY40cocs4lNGSIMQAXooYHMsdoqCiKbQT4Auy073tavPaYiwBW1KDTtq3B7rlroJ4qpbTrfD5VVTlT49YZu0fyYQEPB9wXVuxCfDSHtw0I0hjjDGit6Qd4WZbLr6SmaRYg3Lque4a+fS6EeKB/Rj0ZBACc6rpWfuhXxPsKONjTA8ygkA4q/yXyDetj+SPeuCuUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/img/searchTopBtn1.png
// module id = 3Q5d
// module chunks = 23